import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { isNil } from 'lodash';

@Directive({
  selector: '[appArrayMinLength]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ArrayMinLenghtDirective,
      multi: true,
    }
  ],
})
export class ArrayMinLenghtDirective implements Validator {

  @Input() appArrayMinLength: number;

  constructor() { }

  validate(control: AbstractControl<any, any>): ValidationErrors {

    if (isNil(this.appArrayMinLength)) return null;

    if (!Array.isArray(control.value)) return null;

    if (control.value.length < this.appArrayMinLength) {
      return {
        appArrayMinLength: `You must select at least ${this.appArrayMinLength} items.`,
      };
    }

    return null;
  }

}
